// message.js
export const SET_MESSAGE = 'SET_MESSAGE'
export const ADD_MESSAGE = 'ADD_MESSAGE'
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES'
export const ARRANGE_MESSAGES = 'ARRANGE_MESSAGES'
export const SLICE_MESSAGES = 'SLICE_MESSAGES'
export const PURIFY_MESSAGES = 'PURIFY_MESSAGES'
// user.js
export const SET_USERINFO = 'SET_USERINFO'
// chatroom.js
export const SET_CHATROOMS = 'SET_CHATROOMS'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js